import { c as _c } from "react/compiler-runtime";
import React from 'react';
import JBImage from 'components/essentials/JBImage';
import IconArrowLeft from 'components/icons/iconArrowLeft';
import SmallIconArrowLeft from 'components/icons/iconSimpleArrowLeft';
import SidebarModal from 'components/consumer/SidebarModal';
import useIsTradeUserSidebarOpen from 'global-state/isTradeUserSidebarOpen/useIsTradeUserSidebarOpen';
import useCloseTradeUserSidebar from 'global-state/isTradeUserSidebarOpen/useCloseTradeUserSidebar';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useScreen from 'hooks/useScreen';
const TradeUserSidebar = () => {
  const $ = _c(15);
  const {
    isMobile
  } = useScreen();
  const isTradeUserSidebarOpen = useIsTradeUserSidebarOpen();
  const closeTradeUserSidebar = useCloseTradeUserSidebar();
  const IconArrow = isMobile ? SmallIconArrowLeft : IconArrowLeft;
  let t0;
  if ($[0] !== IconArrow || $[1] !== closeTradeUserSidebar) {
    t0 = <IconArrow width={20} onClick={closeTradeUserSidebar} className="cursor-pointer" />;
    $[0] = IconArrow;
    $[1] = closeTradeUserSidebar;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-base font-bold">Trade Member Discount</div>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0) {
    t2 = <div className="flex pt-[4.5rem] px-8 relative items-center pb-4 max-[767px]:p-4 max-[767px]:justify-center [&_svg]:mr-3 [&_svg]:max-[767px]:left-4 [&_svg]:max-[767px]:absolute">{t0}{t1}</div>;
    $[4] = t0;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="text-xl font-bold">Your Trade Member discount has been applied across the website:</div>;
    t4 = <br />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="pt-12 [border-top:1px_solid_#e5e5e5] max-[767px]:pl-4 max-[767px]:pr-4">{t3}{t4}<ul className="ml-4 last-child:mb-4 list-disc flex flex-col gap-4 mb-6"><li><div className="text-lg font-bold">Up to 50% off non-motorized upholstered products</div></li><li><div className="text-lg font-bold">Up to 40% off casegoods, outdoor, and motorized upholstery products</div></li><li><div className="text-lg font-bold">Up to 30% off decor</div></li></ul><div className="text-center text-base font-bold">Thanks for being a part of our Trade program! Feel free to reach out if you have any questions or need some help.</div></div>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <JBImage width={380} src="https://joybird2.imgix.net/public_img/JB-Email-Trade-Team-Module-V2-Text-Transparent.png" alt="Trade Team" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="px-8 pb-8">{t5}<div className="mt-4 pt-4 [border-top:1px_solid_#f1f1f1] max-[767px]:m-4">{t6}<div className="text-base font-bold text-center mt-1"><a className="text-gray" href="mailto:trade@joybird.com">trade@joybird.com</a><span>  •   </span><a className="text-gray" href="tel:18552084414">855-208-4414</a></div></div></div>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== closeTradeUserSidebar || $[12] !== isTradeUserSidebarOpen || $[13] !== t2) {
    t8 = <SidebarModal isOpen={isTradeUserSidebarOpen} onClose={closeTradeUserSidebar} mobileIsFullHeight={true} desktopNoPadding={true}>{t2}{t7}</SidebarModal>;
    $[11] = closeTradeUserSidebar;
    $[12] = isTradeUserSidebarOpen;
    $[13] = t2;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
export default withBrowserOnly(TradeUserSidebar);